module.exports = __webpack_public_path__ + "img/a.f521abd4.jpg";